import { AuthService } from './../../core/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {

  constructor(private af: AuthService) {
  }

  doSignUp() {
    // this.af.doGoogleLogin();
  }
  ngOnInit() {
  }

}
